<template>
  <router-view v-if="keepAlive" />
  <router-view v-slot="{ Component }" v-else>
    <KeepAlive>
      <component :is="Component" />
    </KeepAlive>
  </router-view>
</template>
<script setup>

defineProps({
  keepAlive: {
    type: Boolean,
    default: true
  }
})

</script>
